import { ClientInput } from 'admin/inputs/ClientInput';
import { DateInput } from 'admin/inputs/DateInput';
import { ExpectedAmountInput } from 'admin/inputs/ExpectedAmountInput';
import { InstitutionInput } from 'admin/inputs/InstitutionInput';
import { ProductStatusInput } from 'admin/products/inputs/ProductStatusInput';
import { PERIOD_TYPE_CHOICES } from 'admin/utils';
import { LifeInsuranceInsuranceRiskType } from 'generated/graphql';
import { RichTextInput } from 'ra-input-rich-text';
import {
  ArrayInput,
  BooleanInput,
  Create,
  FormTab,
  getRecordFromLocation,
  NumberInput,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
} from 'react-admin';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { LifeInsuranceInsuranceRiskTypeTranslations } from 'translations/enums';

// TODO: generalize components

export const LifeInsuranceProductCreate: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const record = getRecordFromLocation(location);
  return (
    <Create>
      <TabbedForm>
        <FormTab label="Základné info">
          <ClientInput disabled={!!record?.clientId} label="Klient" source="clientId" />
          <InstitutionInput source="institutionId" />
          <TextInput label="Vlastná inštitúcia" source="institutionName" sx={{ maxWidth: '40em', width: '100%' }} />
          <TextInput label="Názov produktu" source="name" sx={{ maxWidth: '40em', width: '100%' }} />
        </FormTab>

        <FormTab label="Zmluva">
          <TextInput label="Číslo zmluvy" source="contractNumber" sx={{ maxWidth: '40em', width: '100%' }} />
          <DateInput label="Začiatok poistenia" source="contractSignDate" />
          <DateInput label="Platnosť poistenia do" source="contractEndDate" />
        </FormTab>

        <FormTab label="Platby">
          <ExpectedAmountInput label="Suma poistného" source="paymentPeriod.expectedAmount.amount" />
          <TextInput source="paymentPeriod.expectedAmount.currency" style={{ display: 'none' }} value="EUR" />
          <NumberInput label="Opakovať každých" source="paymentPeriod.periodCount" />
          <SelectInput choices={PERIOD_TYPE_CHOICES} label="" source="paymentPeriod.periodTypeCode" />
          <DateInput label="Nasledujúca platba" source="paymentPeriod.expectedDate" />
        </FormTab>

        <FormTab label="Údaje pre platbu">
          <TextInput
            label="Variabilný symbol"
            source="paymentInfo.variableSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput
            label="Špecifický symbol"
            source="paymentInfo.specificSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput
            label="Konštantný symbol"
            source="paymentInfo.constantSymbol"
            sx={{ maxWidth: '40em', width: '100%' }}
          />
          <TextInput label="IBAN" source="paymentInfo.ibanForPayment" sx={{ maxWidth: '40em', width: '100%' }} />
        </FormTab>

        <FormTab label="Poistenci, poistníci a rozsah poistenia">
          <ArrayInput label="Poistenci, poistníci a rozsah poistenia" source="applicants">
            <SimpleFormIterator inline>
              <TextInput helperText={false} label="Meno" source="name" />
              <TextInput helperText={false} label="Priezvisko" source="surname" />
              <BooleanInput helperText={false} label="Poistenec" source="isInsured" />
              <BooleanInput helperText={false} label="Poistník" source="isInsuring" />
              <ArrayInput label="Poistené riziká" source="insurance.insuranceRisks">
                <SimpleFormIterator inline>
                  <SelectInput
                    choices={[
                      LifeInsuranceInsuranceRiskType.Death,
                      LifeInsuranceInsuranceRiskType.PermanentInjuryConsequences,
                      LifeInsuranceInsuranceRiskType.CriticalIllnesses,
                      LifeInsuranceInsuranceRiskType.Disability,
                      LifeInsuranceInsuranceRiskType.SicknessAbsence,
                      LifeInsuranceInsuranceRiskType.DailyCompensation,
                      LifeInsuranceInsuranceRiskType.Hospitalization,
                      LifeInsuranceInsuranceRiskType.Other,
                    ].map((type) => ({
                      id: type,
                      name: LifeInsuranceInsuranceRiskTypeTranslations(t)[type],
                    }))}
                    helperText={false}
                    label="Typ rizika"
                    source="type"
                  />
                  <TextInput
                    helperText={false}
                    label="Názov rizika"
                    source="name"
                    sx={{ maxWidth: '40em', width: '100%' }}
                  />
                  <NumberInput helperText={false} label="Poistná suma" source="insuredSum.amount" />
                  <NumberInput helperText={false} label="Poistné" source="annualCost.amount" />
                </SimpleFormIterator>
              </ArrayInput>
            </SimpleFormIterator>
          </ArrayInput>
        </FormTab>

        <FormTab label="Informácie o životnom poistení">
          <DateInput defaultValue={new Date()} label="platné k" source="financialDetailsUpdatedAt" />
          <NumberInput label="Výška odkupnej hodnoty" source="surrenderValue.amount" />
        </FormTab>

        <FormTab label="Sporiaca zložka">
          <NumberInput label="Sporiaca zložka" source="savings.amount.amount" />
          <NumberInput label="Poistná suma" source="savings.insuredSum.amount" />
        </FormTab>

        <FormTab label="Status">
          <ProductStatusInput label="Status" source="status" />
        </FormTab>

        <FormTab label="Poznámka">
          <RichTextInput
            label="Poznámka"
            source="note"
            sx={{ '& .tiptap': { minHeight: '20em' }, maxWidth: '40em', width: '100%' }}
          />
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
